module.exports = __webpack_public_path__ + "img/2862ea8.svg";